import { isString } from 'helpers/miscellaneous'

const TEACHER_GENDER = 'teacher_gender'

export const setTeacherGender = gender => {
    if (!gender || !isString(gender)) return

    const prevGenderValue = localStorage.getItem(TEACHER_GENDER)

    if (prevGenderValue !== gender) localStorage.setItem(TEACHER_GENDER, gender)
}

export const getTeacherGender = () => {
    const gender = localStorage.getItem(TEACHER_GENDER)
    const isMale = gender === 'male'
    return {
        gender,
        isMale,
    }
}
